import { Check, Close } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    isCovered: boolean;
    items: string[];
};

export const CoverageBlock = ({ isCovered, items }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full flex-col gap-md rounded-md border border-border-black p-md xsMax:gap-sm">
            <div className="w-fit">
                <H5>
                    {isCovered
                        ? formatMessage({ id: 'purchaseProtectionPage.coverage.whatIsCovered' })
                        : formatMessage({ id: 'purchaseProtectionPage.coverage.whatIsNotCovered' })}
                </H5>
                <div
                    className={cn('mt-xs border-b-4', {
                        'border-border-critical': !isCovered,
                        'border-border-success': isCovered,
                    })}
                />
            </div>
            <div className="flex flex-col gap-xs">
                {items.map((item) => (
                    <div
                        className="flex items-center gap-sm"
                        key={item}
                    >
                        {isCovered ? (
                            <Check
                                color="success"
                                size="sm"
                                style="bold"
                            />
                        ) : (
                            <Close
                                color="critical"
                                size="sm"
                                style="bold"
                            />
                        )}
                        <BodySecondary>{item}</BodySecondary>
                    </div>
                ))}
            </div>
        </div>
    );
};
